const NotificationPaths = {
  NotificationMain: "/Notification",
  NotificationInfo: "/NotificationInfo",
};
export default NotificationPaths;
